export function imageProxyUrl(url, width, height, quality = 90, format = 'jpg', shape = 'cut') {
  if (!url) {
    return ''
  }
  const protocoll = url.match(/^\/\//) ? 'https:' : ''
  const source = escape(protocoll + url)
  return `https://imageproxy.a2d.tv/?retina=true&shape=${shape}&format=${format}&quality=${quality}&resize=${width}x${height}&source=${source}`
}
